// Public config exposed to the client (safe values only)
export const LIMA_CONSULTANT_WHATSAPP = "5534998045668";
export const LIMA_CONSULTANT_DISPLAY = "(34) 99804-5668";

export function buildWaLink(phone, text) {
  const num = (phone || LIMA_CONSULTANT_WHATSAPP).replace(/\D/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text || "")}`;
}
